"use client";
import { styled } from "@mui/material/styles";
import { FontLineHeightLg, SpaceMd, SpaceXs, SpaceSm, DividersSizeBorderWidth, ColorGray500 } from "@nxt-costco-com/forge-design-tokens";
const SimpleList = styled("ul")(() => ({
  listStyle: "none",
  marginTop: 0,
  paddingLeft: 0,
  lineHeight: FontLineHeightLg,
  "> li": {
    "> a": {}
  }
}));
const ExpandableListContainer = styled(SimpleList)({
  marginBottom: 0,
  // MUI by default puts a negative margin on checkbox labels. Since that is a primacy
  // use-case of this component, we will reset them here even though this list can be used
  // for any child type
  "& .MuiFormControlLabel-root": {
    marginLeft: 0
  }
});
const ExpandableListItem = styled("li")({
  marginBottom: SpaceMd
});
const InlineList = styled("ul")(() => ({
  "--gap": SpaceMd,
  listStyle: "none",
  padding: 0,
  display: "inline-flex",
  flexDirection: "row",
  flexWrap: "wrap",
  margin: `calc(-1 * var(--gap)) 0 0 calc(-1 * var(--gap))`,
  width: `calc(100% + var(--gap))`,
  "> li": {
    margin: `var(--gap) 0 0 var(--gap)`
  }
}));
const DividedInlineList = styled(InlineList)(({ theme }) => ({
  "& > li:not(:first-child) /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */": {
    borderLeft: `${DividersSizeBorderWidth} solid ${ColorGray500}`
  },
  "> li": {
    padding: `0 ${SpaceMd}`,
    [theme.breakpoints.down("md")]: {
      padding: `0 ${SpaceSm}`
    },
    [theme.breakpoints.down("sm")]: {
      padding: `0 ${SpaceXs}`
    },
    margin: "0 0"
  }
}));
export {
  DividedInlineList,
  ExpandableListContainer,
  ExpandableListItem,
  InlineList,
  SimpleList
};
